"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountErrorCodes = void 0;
var BankAccountErrorCodes;
(function (BankAccountErrorCodes) {
    BankAccountErrorCodes["INVALID_AGENCY_NUMBER"] = "INVALID_AGENCY_NUMBER";
    BankAccountErrorCodes["INVALID_AGENCY_CHECK_NUMBER"] = "INVALID_AGENCY_CHECK_NUMBER";
    BankAccountErrorCodes["INVALID_ACCOUNT_NUMBER"] = "INVALID_ACCOUNT_NUMBER";
    BankAccountErrorCodes["INVALID_ACCOUNT_CHECK_NUMBER"] = "INVALID_ACCOUNT_CHECK_NUMBER";
    BankAccountErrorCodes["AGENCY_CHECK_NUMBER_DONT_MATCH"] = "AGENCY_CHECK_NUMBER_DONT_MATCH";
    BankAccountErrorCodes["ACCOUNT_CHECK_NUMBER_DONT_MATCH"] = "ACCOUNT_CHECK_NUMBER_DONT_MATCH";
    BankAccountErrorCodes["INVALID_BANK_NUMBER"] = "INVALID_BANK_NUMBER";
})(BankAccountErrorCodes = exports.BankAccountErrorCodes || (exports.BankAccountErrorCodes = {}));
//# sourceMappingURL=BankAccountErrorCodes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/br-bank-account-validator/dist/BankAccountErrorCodes.js
// module id = 874
// module chunks = 1